<form [formGroup]="form" (ngSubmit)="save()">
    <div class="form-row">
        <div class="form-field flex-grow-1">
            <input pInputText type="text" formControlName="sector" class="form-control" [placeholder]="'Sector'">
            <label>Sector</label>
        </div>
        <div class="form-field flex-grow-1">
            <input pInputText type="date" formControlName="desde" class="form-control" [placeholder]="'Ingrese desde'">
            <label>Desde</label>
        </div>
        <div class="form-field flex-grow-1">
            <input pInputText type="date" formControlName="hasta" class="form-control" [placeholder]="'Ingrese hasta'">
            <label>Hasta</label>
        </div>
        <div class="form-field flex-grow-1 mt-1">
            <p-dropdown formControlName="tipoEstado" [options]="tipoEstadoOptions" optionLabel="label"
                optionValue="value" placeholder="Seleccione tipo estado">
            </p-dropdown>
            <label>Tipo Estado</label>
        </div>
        <div class="form-field flex-grow-1 mt-1">
            <p-dropdown formControlName="variableFinanciera" [options]="variableFinancieraOptions" optionLabel="label" appendTo="body"
                optionValue="value" placeholder="Seleccione variable financiera">
            </p-dropdown>
            <label>Variable Financiera</label>
        </div>
        <div class="form-field flex-grow-1">
            <input pInputText type="number" formControlName="valorMinimo" class="form-control"
                [placeholder]="'Ingrese valor mínimo'" step="0.01" min="0">
            <label>Valor Mínimo</label>
        </div>
        <div class="form-field flex-grow-1">
            <input pInputText type="number" formControlName="valorMaximo" class="form-control"
                [placeholder]="'Ingrese valor máximo'" step="0.01" min="0">
            <label>Valor Máximo</label>
        </div>
        <div class="form-field flex-grow-1">
            <input pInputText type="number" formControlName="valorPromedio" class="form-control"
                [placeholder]="'Ingrese valor promedio'" step="0.01" min="0">
            <label>Valor Promedio</label>
        </div>
        <div class="form-field flex-grow-1">
            <input pInputText type="text" formControlName="responsable" class="form-control"
                [placeholder]="'Responsable'">
            <label>Responsable</label>
        </div>
    </div>

    <div class="button-section">
        <button mat-flat-button class="btn-success btn-menu" type="submit" [disabled]="!form.valid || loading">
            <mat-icon>save</mat-icon>
            {{ isEditMode ? 'Actualizar' : 'Guardar' }}
        </button>
    </div>
</form>
